<div *ngIf="!completelyHideNavigation">
  <mat-toolbar *ngIf="isMobile && !errorInAuthentication">
    <button mat-icon-button *ngIf="!showSideNav" (click)="toggleSideNav()">
      <mat-icon>menu</mat-icon>
    </button>
    <button mat-icon-button *ngIf="showSideNav" (click)="toggleSideNav()">
      <mat-icon>clear</mat-icon>
    </button>
    <div *ngIf="!noReportHeader" class="header1">{{currentPage}} <span *ngIf="subPage != ''">/</span> <span
        class="header2" *ngIf="subPage != ''"> {{subPage}}</span></div>
  </mat-toolbar>
</div>

<app-alerts [notifications]='notifications'></app-alerts>

<mat-sidenav-container [ngClass]="{'main-container': !noReportHeader}" *ngIf="user && !errorInAuthentication">
  <!-- <div *ngIf="!completelyHideNavigation"> -->
  <mat-sidenav class="side-panel" #sidenav mode="side" align="start" [(opened)]="showSideNav"
    *ngIf="!completelyHideNavigation">
    <app-side-panel></app-side-panel>
  </mat-sidenav>
  <div [ngClass]="!noReportHeader ? 'profile-container' : 'profile-container-embed'" *ngIf="!completelyHideNavigation">
    <div class="left-container">
      <!-- <div class="subtitle5" [ngClass]="!noReportHeader ? 'back' : 'back-embed'" (click)="goBack()" *ngIf="subPage.length > 0">
        <div class="logo" *ngIf="noReportHeader">
          <img src="../../assets/maxis_logo.svg" />
        </div>
        <div>
          <img class="back-button" alt="button" src="assets/icons/chevron-left.svg">{{plaintext.back[user.language]}}
        </div>
      </div> -->
      <div *ngIf="!noReportHeader && !isMobile" class="header1">{{currentPage}} <span *ngIf="subPage != ''">/</span>
        <span class="header2" *ngIf="subPage != ''"> {{subPage}}</span>
      </div>
    </div>
    <div class="right-container" *ngIf="!isMobile && !noReportHeader">
      <div class="header-text subtitle2" i18n="@@welcome" *ngIf="user && !isAdmin">
        Welcome Back,
        {{user.name}}</div>
    </div>
  </div>
  <!-- </div> -->
  <!-- <mat-toolbar>
      <mat-toolbar-row  class="profile-container"> 
        <div class="subtitle5" *ngIf="subPage != '' || currentPage == 'Reports' || currentPage == '/dashboard' || isDashView || noReportHeader">
          <a href = "/admin" class = "hyperLink">
          <img class="back-button" alt="button"
            src="assets/icons/chevron-left.svg">BACK</a>
        </div>
        <div class="header-text subtitle2" i18n="@@welcome" *ngIf="user">Welcome Back, {{user.name}}</div>
        <div *ngIf="user && user.duns">DUNS: {{user.duns}}</div>
      </mat-toolbar-row>
      <mat-toolbar-row class="page-description">
        <div *ngIf = "!noReportHeader" class="header1">{{currentPage}} <span *ngIf="subPage != ''">/</span> <span class="header2"
            *ngIf="subPage != ''"> {{subPage}}</span></div> -->
  <!-- <div class="position-title" *ngIf="currentPage == 'My Dashboard'">{{positionTitle}} - {{location}}</div> -->
  <!-- </mat-toolbar-row>
  
    </mat-toolbar> -->

  <router-outlet></router-outlet>

  <div *ngIf="!noReportHeader" class="footer-padding"></div>

</mat-sidenav-container>

<div *ngIf="errorInAuthentication && errorCode != 403" class="auth-error">
  <mat-card class="auth-error-card">
    <mat-card-content>
      <div *ngIf="errorCode === 405">
      <h2>
        Access Not Authorized - Supplier Quality Management System (SQMS_SUPPLIER) Not Found
      </h2>
        <p>
          It looks like you don't have access to Supplier Quality Management System(SQMS_SUPPLIER). Please request SQMS access from company administrator in SupplyPower portal.
        </p>
      </div>      
      <div *ngIf="errorCode !== 405">
        <h2>
          Something went wrong signing in.
        </h2>
        <p *ngIf="errorCode === 404">
          It looks like you don't have access to Supplier Quality Management System(SQMS_SUPPLIER). Please request SQMS access from company administrator in SupplyPower portal.
        </p>
        <p *ngIf="errorCode === 401">
          It looks like you do not have access. Please reach out to maxisfor3rdparties@gm.com to request access.
        </p>        
      </div>
    </mat-card-content>
  </mat-card>
</div>